// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_84-4";
export var collapsed = "_84-1";
export var headerBar = "_84-0";
export var leftHeaderContent = "_84-3";
export var subjectContainer = "_84-2";